module.exports = __webpack_public_path__ + "../resources/img/bg_wrapper copy.20dc9a6a.jpg";